export const LOGO_MARK = "/images/tsm-mark.png";

export const LOGO_WORD =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_nexus-audit-1/artifacts/easl7l47_Word%20HEAD.jpg";

export const CONTACT_EMAIL = "admin@tsmnexus.com";

/* Calendly — Founding Cohort / Full Diagnostic booking page */
export const CALENDLY_URL =
  "https://calendly.com/full-diagnostic-revenue-audit-tsmnexus/tsm-nexus-full-diagnostic";

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/method", label: "The Method" },
  { to: "/guide", label: "Field Guide" },
  { to: "/cohort", label: "Founding Cohort" },
  { to: "/contact", label: "Contact" },
];

/* Verified external profiles — opened in a new tab, safely. */
export const SOCIALS = [
  {
    icon: "linkedin",
    label: "TSM Nexus on LinkedIn",
    href: "https://www.linkedin.com/company/tsmnexus/",
  },
  {
    icon: "instagram",
    label: "TSM Nexus on Instagram",
    href: "https://www.instagram.com/tsmnexus/",
  },
];
